<template>
    <div>
        <app-gridview 
            v-bind:parentData = "{
                tabHeaders: this.dataHeader,
                tabItems: this.dataItems,
                pageTitle: this.pageTitle,
                search: this.search,
            }"
            v-on:EditItem="editItemHandler($event)"
            v-on:DeleteItem="deleteItemHandler($event)"
            v-on:NewPressed="newRecordHandler"
        ></app-gridview>
    </div>
</template>
<script>

import GridView from '../../../components/common/GridView';

export default {
    components: {
        'app-gridview': GridView
    },

    data() {
        return {
            pageTitle: this.$t('setupservicerectype.servicerectypelist'),
            dataHeader: [
                { text: this.$t('columns.actions'), value: 'action', sortable: false, width: '50px' },
                { text: this.$t('columns.recordtype'), value: 'movcode', width: '150px' },
                { text: this.$t('columns.description'), value: 'movdesc', width: '200px' },
                { text: this.$t('columns.remark'), value: 'remark', width: '200px' },
                { text: this.$t('columns.disable'), value: 'isdisable', width: '50px' },
            ],
            dataItems: [],
            loading: false,
            errMsg: '',
             search: this.$route.params.search,
        }
    },

    methods: {
        getServiceRecordListHandler() {
            const vm = this;

            this.loading = !this.loading;

            this.$store.dispatch('get', {url: '/movtype/all'})
                .then(function (res) {
                    vm.dataItems = res.data.rec;

                    vm.loading = !vm.loading;
                })
                .catch(function (err) {
                    vm.errMsg = err;
                });

        },

        editItemHandler(item) {
            this.$router.push({name: 'servicerecordedit', params: { id: item.id, search: item.search  } });
        },

        newRecordHandler() {
            this.$router.push({name: 'servicerecordnew'});
        }
    },

    mounted() {
        this.getServiceRecordListHandler();
    }
}
</script>